import { z } from 'zod';

const authResponseSchemas = {
  acceptInvite: z.object({
    success: z.boolean(),
    message: z.string(),
    token: z.string(),
  }),
  sendOtp: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  verifyOtp: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
} as const;

export default authResponseSchemas;
